import axiosInstance from "./axiosInstance";

// Get all reviewchannels
export const fetchReviewChannels = async () => {
  const response = await axiosInstance.get("/reviewchannel/getall");
  return response.data;
};


// Get reviewchannel by ID
export const getReviewChannelById = async (id) => {
  const response = await axiosInstance.get(`/reviewchannel/get?reviewchannelId=${id}`);
  return response.data;
};

// Create a new reviewchannel
export const createReviewChannel = async (data) => {
  const response = await axiosInstance.post("/reviewchannel", data);
  return response.data;
};

// Create a new reviewchannel
export const voteReviewChannel = async (data) => {
  const response = await axiosInstance.post("/reviewchannel/vote", data);
  return response.data;
};

// Update a reviewchannel
export const syncStasticReviewChannel = async ({ data }) => {
  const response = await axiosInstance.put(`/reviewchannel/syncstastic}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response.data;
};

// Update a reviewchannel
export const updateReviewChannel = async ({ data }) => {
  const response = await axiosInstance.put(`/reviewchannel}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response.data;
};

// Delete a reviewchannel
export const deleteReviewChannel = async (id) => {
  await axiosInstance.delete(`/reviewchannel?ReviewChannelId=${id}`);
};


// Get reviewchannel by ID
export const getReviewChannelCommentByRCId = async (reviewChannelId, userId) => {
  const response = await axiosInstance.get(`/reviewchannel/comment/getall?reviewChannelId=${reviewChannelId}&userId=${userId}`);
  return response.data;
};

// Create a new reviewchannel
export const createReviewChannelComment = async (data) => {
  const response = await axiosInstance.post("/reviewchannel/comment", data);
  return response.data;
};

// Delete a reviewchannel
export const deleteReviewChannelComment = async (id) => {
  await axiosInstance.delete(`/reviewchannel/comment?ReviewChannelId=${id}`);
};
